export default __webpack_public_path__ + "static/media/metamask.4368e45a.svg";